

export class MmfVuexStoreHelper {
    constructor(store) {
        this.store = store
    }
    namespaced() {
        this.store.namespaced = true
        return this
    }
    withStates(states) {
        Object.assign(this.store['state'], states)
        return this
    }
    withActions(actions) {
        Object.assign(this.store['actions'], actions)
        return this
    }
    withMutations(mutations) {
        var currentMutations = this.store['mutations']
        Object.assign(currentMutations, mutations)
        return this
    }
    withPatternFactory(pattenFactory,param){
        pattenFactory({store : this.store, param})
        return this
    }
    buildStore() {
        return this.store
    }
}